import React from 'react'
import { Grid, GridItem, Img, Text, VStack } from '@chakra-ui/react'
import { PaymentRequestButtonElement, PaymentElement } from '@stripe/react-stripe-js'
import { PaymentRequest } from '@stripe/stripe-js'
import { observer } from 'mobx-react'
import { convertNumberToUSD } from 'utils/common'

export interface ICheckoutFormMainSectionProps {
  amount: number
  paymentRequest?: PaymentRequest | null
}

const CheckoutFormMainSection = (props: ICheckoutFormMainSectionProps) => {
  const { amount, paymentRequest } = props

  return (
    <VStack spacing={{ base: 6, lg: 8 }} width="stretch">
      <Text alignSelf="flex-start" fontSize="md" fontWeight="500" color="gray.700">
        We need to do a background check before continuing. You will be charged
        <b>{` ${convertNumberToUSD(amount)}`}.</b>
      </Text>
      {paymentRequest && (
        <>
          <PaymentRequestButtonElement options={{ paymentRequest }} />
          <Img minHeight={10} src="/assets/images/divider.svg" alt="divider" objectFit="none" objectPosition="center" />
        </>
      )}
      <Grid templateColumns="repeat(4, 1fr)" gap={2} width="full">
        <GridItem>
          <Img src="/assets/images/card/visa.png" alt="Visa" />
        </GridItem>
        <GridItem>
          <Img src="/assets/images/card/masterCard.png" alt="MasterCard" />
        </GridItem>
        <GridItem>
          <Img src="/assets/images/card/americanExpress.png" alt="American Express" />
        </GridItem>
        <GridItem>
          <Img src="/assets/images/card/discover.png" alt="Discover" />
        </GridItem>
      </Grid>
      <PaymentElement />
    </VStack>
  )
}

export default observer(CheckoutFormMainSection)
